// extracted by mini-css-extract-plugin
export var alertIcon = "_su-0";